import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class PasswordModalService {

  constructor(private _http: HttpClient) { }

  checkPassword(password, templateId) {
    return this._http.get(environment.url + "/embedLinkAuth/" + password + "/" + templateId);
  }

}
